import { createStore } from "vuex";

export default createStore({
  state: {
    project: 'JamSplit',
    desc: '',
    user: null,
    profile: null,
    activeCommentId: null,
    activeEditCommentId: null,
    theme: 'light',
    genders: ['Male', 'Female', 'Non-Binary', 'Prefer Not to Say'],
    levels: ['Beginner', 'Intermediate', 'Advanced', 'Professional'],
    instruments: [
      'Acoustic Guitar',
      'Electric Guitar',
      'Bass',
      'Drums',
      'Piano/Keyboard',
      'Vocals',
      'Saxophone',
      'Trumpet',
      'Trombone',
      'Harmonica',
    ],
    genres: [
      'Rock',
      'Pop',
      'Jazz',
      'Blues',
      'Country',
      'Folk',
      'Metal',
      'Hip-Hop',
      'R&B/Soul',
      'Reggae',
      'Funk',
      'Gospel',
      'Punk',
      'Bluegrass',
      'Latin',
    ],
    tempSessions: [],
    tempSong: null,
  },
  getters: {
    getTempSessionByJobId: (state) => (jobId) => {
      return state.tempSessions.find(session => session.jobId === jobId)
    },
  },
  mutations: {
    updateTempSessionName(state, { jobId, sessionName }) {
      const session = state.tempSessions.find(session => session.jobId === jobId)
      if (session) {
        session.sessionName = sessionName
      }
    },
    deleteTempSession(state, jobId) {
      state.tempSessions = state.tempSessions.filter(session => session.jobId !== jobId)
    },
    pushSongToTempSession(state, { jobId, songId }) {
      const session = state.tempSessions.find(s => s.jobId === jobId);
      if (session) {
        session.songs = [songId, ...(session.songs || [])];
      }
    }
  },
  actions: {
  },
});
